import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable, of } from 'rxjs'

import { ConstantUrls } from '../../../constants/constant.urls'
import { GetURL } from '../../../constants/get-url'

@Injectable({
  providedIn: 'root',
})
export class VgnContentService {
  fallBackJson = {}
  public externalNotLoggedInFallback = require('../../../../contingency/external_not_logged_in_fallback.json')
  public externalLoggedInFallback = require('../../../../contingency/external_logged_in_fallback.json')
  constructor(private readonly _http: HttpClient) {}

  getVgnContent(inUserLoggedOn: boolean): Observable<any> {
    return this._http
      .get<any>(
        GetURL(`${ConstantUrls.NODE_FD3_VGN_CONTENT}/${inUserLoggedOn}`),
      )
      .pipe(
        catchError(() => {
          if (!inUserLoggedOn) {
            this.fallBackJson = this.externalNotLoggedInFallback
          } else {
            this.fallBackJson = this.externalLoggedInFallback
          }
          return of(this.fallBackJson)
        }),
      )
  }
}
